import "jquery-sticky";
import "../css/blog.scss";
import Utils from './utils';
import Boom from "./nav-click";
$(document).ready(function () {
    // Boom.init('#blog');
    setTimeout(function () {

        if (window.matchMedia("(min-width: 769px)").matches) {
            const $rel = $(`.blog_related`);
            $(".product_ncp").sticky({
                topSpacing: $('.header-nav').outerHeight(false) + 15,
                bottomSpacing: ($rel.length ? $rel.outerHeight(true) : 0) + $('.footer_wrap').outerHeight(true) + 80 + 15
            });
        }
    });
    $(".blog-wrap").on('click', ".blog_tile .thumb-wrap,.blog_tile .ghost_button", Boom.boom);

    function pushHistory(url, title) {
        try {
            if (url == window.location.href) {
                //the same
                return;
            }
            window.history.pushState({url: window.location.href}, title, url);
            if (typeof title != "undefined") {
                document.title = title;
            }
        } catch (e) {
            console.error("[exception] pushstate")
        }
    }


    $(".sort_link").click(function (ev) {
        const $blog = $('#blog'), el = ev.currentTarget, $el = $(el), url = el.href;
        if ($el.hasClass('active')) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        $('.sort_link.active').removeClass('active');
        $el.addClass('active');
        Utils.putSpinnerOn($(".blog-wrap"));
        pushHistory(url);
        $("html,body").animate({scrollTop: $('.posts_sort').offset().top - $('.header-nav').outerHeight(true)}, 500);
        Utils.fetchJson(url + '&ajax=yes').then((json) => {
            $blog.replaceWith(json.fragments['#blog']);
            Utils.disableSpinner(300);
            FB.XFBML.parse();
        });
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    });
    $('form.search').on('submit', function (ev) {
        const formEl = ev.currentTarget;
        Utils.putSpinnerOn($(".blog-wrap"));
        Utils.fetchJson(formEl.getAttribute('action'), new FormData(formEl), "POST").then((json) => {
            $("#blog").replaceWith(json.fragments['#blog']);
            Utils.disableSpinner(300);
            FB.XFBML.parse();
        });
        ev.preventDefault();
        ev.stopPropagation();
    })
});



// WEBPACK FOOTER //
// ./assets/js/blog.js